import axios from "axios";
import moment from "moment";
import bus from "@/EventBus";

export default {
  namespaced: true,
  state: {
    tarifas: [],
    tarifa: {},
    precio: null,
  },
  mutations: {
    llenarTarifas(state, data) {
      state.preciosBasic = [];
      state.preciosBasic = data;
    },
    llenarTarifa(state, data) {
      state.preciosPremium = {};
      state.preciosPremium = data;
    },
  },
  actions: {
    getTarifas: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;

      await axios
        .get("tarifas/", configuracion)
        .then(function(response) {
          // response.data.forEach((element) => {
          //   element.fecha_recogida = moment(element.fecha_recogida).format("LL");
          //   element.fecha_entrega = moment(element.fecha_entrega).format("LL");
          // });
          data = response.data;
          commit("llenarTarifas", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getTarifa: async function({ commit }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      let d = null;
      debugger;
      await axios
        .get(`tarifas?id=${data.id}`, configuracion)
        .then(function(response) {
          d = response.data.detalles;
          commit("llenarTarifa", d);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveReserva: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };

      debugger;
      await axios
        .post(
          "tarifas/",
          {
            id_usuario: data.usuario,
            id_coche: data.obj.id_coche,
            coche_marca: data.obj.coche_marca,
            coche_modelo: data.obj.coche_modelo,
            coche_grupo: data.obj.coche_grupo,
            coche_matricula: data.obj.coche_matricula,
            id_persona: data.obj.id_persona,
            nombre: data.obj.nombre,
            apellido: data.obj.apellido,
            telefono: data.obj.telefono,
            edad_conductor: data.obj.edad_conductor,
            email: data.obj.email,
            tipo_francdepos: data.obj.tipo_francdepos,
            valor_francdepos: data.obj.valor_francdepos,
            tarifa: data.obj.tarifa,
            total: data.obj.total,
            fecha_entrega: data.obj.fecha_entrega,
            fecha_recogida: data.obj.fecha_recogida,
            hora_entrega: data.obj.hora_entrega,
            hora_recogida: data.obj.hora_recogida,
            lugar_entrega: data.obj.lugar_entrega,
            lugar_recogida: data.obj.lugar_recogida,
            observaciones: data.obj.observaciones,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getTarifas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Reserva ${res.data.id} agregada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    sendEmail: async function({ commit }, data) {
      await axios
        .post("email/confirm", {
          dataReserva: data.res,
        })
        .then(function() {
          swal({
            title: "Buen trabajo!",
            text: `Email enviado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}. Informe al departamento de desarrollo`,
            icon: "error",
          });
        });
      commit();
    },
    updateReserva: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .put(
          "reserva/update",
          {
            id: data.obj.id,
            id_usuario: data.usuario,
            id_coche: data.obj.id_coche,
            coche_marca: data.obj.coche_marca,
            coche_modelo: data.obj.coche_modelo,
            coche_grupo: data.obj.coche_grupo,
            coche_matricula: data.obj.coche_matricula,
            id_persona: data.obj.id_persona,
            nombre: data.obj.nombre,
            apellido: data.obj.apellido,
            telefono: data.obj.telefono,
            edad_conductor: data.obj.edad_conductor,
            email: data.obj.email,
            tipo_francdepos: data.obj.tipo_francdepos,
            valor_francdepos: data.obj.valor_francdepos,
            tarifa: data.obj.tarifa,
            total: data.obj.total,
            fecha_entrega: data.obj.fecha_entrega,
            fecha_recogida: data.obj.fecha_recogida,
            hora_entrega: data.obj.hora_entrega,
            hora_recogida: data.obj.hora_recogida,
            lugar_entrega: data.obj.lugar_entrega,
            lugar_recogida: data.obj.lugar_recogida,
            observaciones: data.obj.observaciones,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getReservas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Reserva ${res.data.id} actualizada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    activateReserva: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      //debugger
      await axios
        .put(`reserva/activate`, { id: data.id }, configuracion)
        .then(function() {
          dispatch("getReservas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Reserva activada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    deactivateReserva: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .put("reserva/deactivate", { id: data.id }, configuracion)
        .then(function() {
          dispatch("getReservas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Reserva desactivada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    deleteReserva: async function({ dispatch }, data) {
      let token = data.token;
      let header = { Token: token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .delete(`reserva/remove?id=${data.id}`, configuracion)
        .then(function() {
          // debugger
          dispatch("getReservas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Reserva eliminada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
  },
};
